<template>
  <el-dialog :title="$t('ocean-bi::order-link::设置')" width="600px" :visible.sync="visible">
    <div class="edit-wrap">
      <el-form ref="form" :model="form" label-width="80px" label-position="top">
        <el-form-item :label="$t('ocean-bi::order-link::时间范围')">
          <el-date-picker
            v-model="form.time"
            type="datetimerange"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('system::common::start_date')"
            :end-placeholder="$t('system::common::end_date')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('ocean-bi::order-link::图表类型')">
          <div class="chart-wrap">
            <div class="chart-item" :class="{ active: form.chartType == item.key }" v-for="item in charts" :key="item.key" @click="form.chartType = item.key">
              <img :src="form.chartType == item.key ? item.ableSrc : item.disableSrc" />
              <p>{{ item.name }}</p>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'editDialog',
  data() {
    return {
      visible: false,
      form: {
        time: [],
        chartType: ''
      },
      charts: [
        {
          key: 'line',
          name: this.$t('ocean-bi::order-link::折线图'),
          disableSrc: require('@/assets/images/createGraph/chart-line.png'),
          ableSrc: require('@/assets/images/createGraph/chart-line-light.png')
        },
        {
          key: 'bar',
          name: this.$t('ocean-bi::order-link::柱形图'),
          disableSrc: require('@/assets/images/createGraph/chart-bar.png'),
          ableSrc: require('@/assets/images/createGraph/chart-bar-light.png')
        }
      ]
    }
  },
  props: {
    value: {},
    editChart: {}
  },
  methods: {
    submit() {
      this.$emit('update', {
        startDate: this.form.time[0],
        endDate: this.form.time[1],
        chartType: this.form.chartType,
      })
      this.visible = false
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.form.time = [this.editChart.startDate, this.editChart.endDate]
        this.form.chartType = this.editChart.chartType
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-wrap {
  display: flex;
  flex-wrap: wrap;
  .chart-item {
    padding: 10px;
    border: 1px solid #999999;
    text-align: center;
    line-height: 1;
    border-radius: 8px;
    margin-right: 20px;
    color: #999999;
    cursor: pointer;
    &.active {
      border: 1px solid rgb(0, 172, 193);
      color: rgb(0, 172, 193);
    }
    img {
      margin-bottom: 10px;
    }
  }
}
</style>
